module.exports = __webpack_public_path__ + "assets/img/banner4.d8ac4b92.png";